var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlidersThin = function SvgSlidersThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.167 16.607a.6.6 0 0 1 .6.6v1.483h4.609a.6.6 0 0 1 0 1.2h-4.61v1.484a.6.6 0 0 1-1.199 0v-4.167a.6.6 0 0 1 .6-.6M12 18.69a.6.6 0 1 1 0 1.2H2.625a.6.6 0 1 1 0-1.2zM7.833 9.315a.6.6 0 0 1 .6.6v4.167a.6.6 0 0 1-1.2 0v-1.484H2.625a.6.6 0 1 1 0-1.2h4.608V9.915a.6.6 0 0 1 .6-.6m13.542 2.083a.6.6 0 1 1 0 1.2H12a.6.6 0 1 1 0-1.2zm-7.292-9.375a.6.6 0 0 1 .6.6v1.483h6.692a.6.6 0 1 1 0 1.2h-6.692V6.79a.6.6 0 0 1-1.2 0V2.623a.6.6 0 0 1 .6-.6M9.917 4.106a.6.6 0 0 1 0 1.2H2.625a.6.6 0 1 1 0-1.2z"
  })));
};
export default SvgSlidersThin;